export default __webpack_public_path__ + "static/kv-banner-lt-chs-d9b5a5e961c24cb6593560c4d3e727b7.png";